export default __webpack_public_path__ + "static/media/VoteStageLoader.70a77640.webp";